import React from "react";
import PropTypes from "prop-types";
import ActionsCog from "../shared/general/ActionsCog";
import { Actions } from "./styles/engaged-styles";

const AwaitingActions = (props) => {
  const {
    acceptUrl,
    rejectUrl,
    acceptOnClick,
    rejectOnClick,
    engagementId,
    jobId,
  } = props;

  const cogActions = [
    {
      name: "Accept",
      id: 2,
      clickAction: () => {
        acceptOnClick(acceptUrl);
      },
    },
    {
      name: "Reject",
      id: 3,
      clickAction: () => {
        rejectOnClick(rejectUrl, engagementId, jobId);
      },
    },
  ];

  return (
    <Actions data-test-id="awaiting_action_cog">
      <ActionsCog actions={cogActions} />
    </Actions>
  );
};

AwaitingActions.propTypes = {
  acceptUrl: PropTypes.string.isRequired,
  rejectUrl: PropTypes.string.isRequired,
  acceptOnClick: PropTypes.func.isRequired,
  rejectOnClick: PropTypes.func.isRequired,
  engagementId: PropTypes.number.isRequired,
  jobId: PropTypes.number.isRequired,
};

export default AwaitingActions;
